module.exports = __webpack_public_path__ + "assets/img/login-logo.86ad3272.png";